import React, {Component} from "react";
import './Orders.scss';
import moment from 'moment';
import 'moment/locale/he';
import uuid from "uuid";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import MotorcycleIcon from '@material-ui/icons/MotorcycleRounded';
import DoneIcon from '@material-ui/icons/DoneRounded';
import AlarmIcon from '@material-ui/icons/AlarmRounded';
import Fab from "@material-ui/core/Fab";
import AddIcon from '@material-ui/icons/AddRounded';
import axios from "axios";
import {
    FocusOrder,
    OrderClickedOnGrid,
    OrderClickedOnMap,
    OrderHoverOnGrid,
    OrderHoverOnMap,
    OrderHoverOutOnGrid,
    OrderHoverOutOnMap
} from "../../Events/topics";
import {eventsSubject, publish} from "../../Events/events";
import * as permissionTypes from "../../Utils/Permissions/PermissionTypes";
import {AppContext} from "../Utils/AppContext";
import AddEditOrderDialogContainer from "../../Redux/containers/AddEditOrderDialogContainer";
import OrdersGrid from "./OrdersGrid/OrdersGrid";
import NoOrders from "./NoOrders/NoOrders";
import {Tooltip, withStyles} from "@material-ui/core";
import {isEqual, orderBy} from "lodash";
import {filter} from "rxjs/operators";
import {shallowEqualObjects} from "shallow-equal";
import AreYouSureDialog from "../Utils/AreYouSureDialog/AreYouSureDialog";
import BarcodePasteReaderListenerDialogContainer
    from "../../Redux/containers/BarcodePasteReaderListenerDialogContainer";
import {sessionGet, sessionSet} from "../../Utils/SessionStorageUtils";
import {evaluateOrderGroups} from "../../Utils/OrdersGrouping";

const momentLocale = 'he';
moment.locale(momentLocale);
moment.relativeTimeThreshold('m', 180);
moment.relativeTimeRounding(Math.floor);

@withStyles({
    actionItemStyles: {
        whiteSpace: "nowrap",
        borderRadius: "10px",
        "&$selected": {
            backgroundColor: "#e9e9e9",
            border: "1px solid #c7c7c7",
            color: "#505050",
        }
    },
    selected: {}
})
class Orders extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.ordersGridRef = React.createRef();

        this.focusOrderSubscription = eventsSubject
            .pipe(filter(f => f.topic === FocusOrder))
            .subscribe(data => this.onFocusOrder(data));

        this.orderClickedOnMapSubscription = eventsSubject
            .pipe(filter(f => f.topic === OrderClickedOnMap))
            .subscribe(data => this.onOrderClickedOnMap(data));

        this.orderHoverOnMapSubscription = eventsSubject
            .pipe(filter(f => f.topic === OrderHoverOnMap))
            .subscribe(data => this.onOrderHoverOnMap(data));

        this.orderHoverOutOnMapSubscription = eventsSubject
            .pipe(filter(f => f.topic === OrderHoverOutOnMap))
            .subscribe(data => this.onOrderHoverOutOnMap(data));

        this.state = {
            ordersNavigation: "ACCEPTED_READY",
            ordersByNavigation: {
                "ACCEPTED_READY": [],
                "ON_THE_WAY": [],
                "DELIVERED": []
            },
            sureDeleteOrderId: undefined,
            ignoredOrderIdsForGrouping: sessionGet("ignoredOrderIdsForGrouping") || []
        };
    }

    componentWillUnmount() {
        this.focusOrderSubscription.unsubscribe();
        this.orderClickedOnMapSubscription.unsubscribe();
        this.orderHoverOnMapSubscription.unsubscribe();
        this.orderHoverOutOnMapSubscription.unsubscribe();
    }

    onOrderHoverOnMap(m) {
        this.setState({
            focusedOrderId: m.data.orderId
        });
    }

    onOrderHoverOutOnMap(m) {
        this.setState({
            focusedOrderId: null
        });
    }

    onOrderClickedOnMap(m) {
        if (m.data.orderId && this.state.ordersByNavigation[this.state.ordersNavigation].find(o => o.id === m.data.orderId)) {
            this.ordersGridRef.current.scrollTo(m.data.orderId);
        }
    }

    onFocusOrder(m) {
        if (!m.data.orderId) {
            if (this.focusOrderIdTimeout)
                clearTimeout(this.focusOrderIdTimeout);

            this.setState({
                focusedOrderId: null
            });

            return;
        }

        this.ordersGridRef.current.scrollTo(m.data.orderId);

        this.setState({
            focusedOrderId: '-1'
        });

        this.focusOrderIdTimeout = setTimeout(() => {
            this.setState({
                focusedOrderId: m.data.orderId
            });

            this.focusOrderIdTimeout = setTimeout(() => {
                this.setState({
                    focusedOrderId: '-1'
                });

                this.focusOrderIdTimeout = setTimeout(() => {
                    this.setState({
                        focusedOrderId: m.data.orderId
                    });

                    this.focusOrderIdTimeout = setTimeout(() => {
                        this.setState({
                            focusedOrderId: '-1'
                        });

                        this.focusOrderIdTimeout = setTimeout(() => {
                            this.setState({
                                focusedOrderId: m.data.orderId
                            });

                            this.focusOrderIdTimeout = null;
                        }, 400);
                    }, 400);
                }, 400);
            }, 400);
        }, 400);
    }

    onOrderClicked(orderId) {
        publish(OrderClickedOnGrid, {orderId: orderId});
    }

    onRowHover(orderId) {
        if (this.rowHoverOrderId !== orderId) {
            publish(OrderHoverOnGrid, {orderId: orderId});
            this.rowHoverOrderId = orderId;
        }
    }

    onRowHoverOut(orderId) {
        if (this.rowHoverOrderId) {
            publish(OrderHoverOutOnGrid, {orderId: orderId});
            this.rowHoverOrderId = undefined;
        }
    }

    getOrdersByNavigation(orders, assignedDeliveryGroups, navigation) {
        const navigationToStatuses = {
            "ACCEPTED_READY": {
                statuses: ["ACCEPTED", "READY", "SCHEDULED_READY", "ASSIGNED_SCHEDULED_READY"],
                sort: {
                    keys: ["orderTime"],
                    directions: ["asc"]
                }
            },
            "ON_THE_WAY": {
                statuses: ["ASSIGNED", "COLLECTED", "ASSIGNED_TO_ORCA"],
                sort: {
                    keys: ["orderTime"],
                    directions: ["asc"]
                }
            },
            "DELIVERED": {
                statuses: ["DELIVERED"],
                sort: {
                    keys: ["orderTime"],
                    directions: ["desc"]
                }
            }
        };

        const showStatuses = navigationToStatuses[navigation].statuses;
        const sort = navigationToStatuses[navigation].sort;
        const navigationOrders = orders.filter(order => showStatuses.indexOf(order["status"]) > -1);
        const sortedNavigationOrders = orderBy(navigationOrders, sort.keys, sort.directions)

        if (assignedDeliveryGroups) {
            const assignedOrdersSet = new Set(assignedDeliveryGroups.flatMap(g => g.route.map(so => so.order_id)));

            return sortedNavigationOrders.map(o => {
                const allowEdit = !assignedOrdersSet.has(o.id) && o.status !== 'ASSIGNED_TO_ORCA' && o.bid === this.context.bid;
                return {...o, allowEdit: allowEdit}
            });
        }

        return sortedNavigationOrders.map(o => {
            return {...o, allowEdit: true}
        });
    }

    filterOrdersByNavigators(deliveryOrders, assignedDeliveryGroups) {
        return {
            "ACCEPTED_READY": this.getOrdersByNavigation(deliveryOrders, assignedDeliveryGroups, "ACCEPTED_READY"),
            "ON_THE_WAY": this.getOrdersByNavigation(deliveryOrders, assignedDeliveryGroups, "ON_THE_WAY"),
            "DELIVERED": this.getOrdersByNavigation(deliveryOrders, assignedDeliveryGroups, "DELIVERED")
        }
    }

    componentDidMount() {
        this.setState({
            ordersByNavigation: this.filterOrdersByNavigators(this.props.deliveryOrders, this.props.assignedDeliveryGroups || [])
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.deliveryOrders !== nextProps.deliveryOrders || !isEqual(
            (this.props.assignedDeliveryGroups || []).map(g => {
                return {id: g.id, status: g.status, messengerId: g.messenger_id, orderIds: g.route.map(s => s.order_id)}
            }),
            (nextProps.assignedDeliveryGroups || []).map(g => {
                return {id: g.id, status: g.status, messengerId: g.messenger_id, orderIds: g.route.map(s => s.order_id)}
            }))) {
            this.setState({
                ordersByNavigation: this.filterOrdersByNavigators(nextProps.deliveryOrders, nextProps.assignedDeliveryGroups || [])
            });
        }
    }

    async onOrderDeparturePlaceChanged(orderId, value) {
        const currentOrder = this.props.deliveryOrders.find((order) => order.id === orderId);

        const newOrder = {...currentOrder, placeOfDeparture: value};

        this.props.editOrder(newOrder);
    }

    onOrderDeleteClicked(orderId) {
        this.setState({
            sureDeleteOrderId: orderId
        });
    }

    onSureDeleteOrder() {
        this.props.deleteOrder(this.props.match.params.bid, this.state.sureDeleteOrderId);

        this.setState({
            sureDeleteOrderId: undefined
        });
    }

    onNotSureDeleteOrder() {
        this.setState({
            sureDeleteOrderId: undefined
        });
    }

    onOrderEditClicked(orderId, isBadAddress = false) {
        this.setState({
            addEditOrderIdForDialog: orderId,
            isBadAddress: isBadAddress
        });
    }

    evaluateDeliveryGroups() {
        let grouping = undefined;

        if (this.props.isMerukazotEnabled) {
            const ignoredOrderIdsForGrouping = sessionGet("ignoredOrderIdsForGrouping") || [];
            const groups = evaluateOrderGroups(
                this.props.deliveryOrders.filter(order => order.status === "READY"),
                this.props.merukazotMin,
                ignoredOrderIdsForGrouping);
            const lockedOrderIds = this.props.lockedDeliveryGroups.flatMap(lockedGroup => lockedGroup.order_ids);
            const nonSingleGroups = groups.filter(group => group.length > 1 && !group.some(order => lockedOrderIds.includes(order.id)));

            grouping = {
                'groups': nonSingleGroups.map(groupOrders => ({
                    'groupId': "merukazot~" + uuid.v4(),
                    'orderIds': groupOrders.map(order => order.id),
                    'isLocked': true,
                    'isOrdered': true
                }))
            }
        }

        this.props.evaluateDeliveryGroups(this.props.match.params.bid, grouping);
    }

    onGroupOffClicked(orderIds) {
        let ignoredOrderIdsForGrouping = sessionGet("ignoredOrderIdsForGrouping") || [];
        ignoredOrderIdsForGrouping = ignoredOrderIdsForGrouping.concat(orderIds);
        sessionSet("ignoredOrderIdsForGrouping", ignoredOrderIdsForGrouping, 1440);
        this.setState({
            ignoredOrderIdsForGrouping: ignoredOrderIdsForGrouping
        });
        this.evaluateDeliveryGroups();
    }

    onAddEditOrderCancel() {
        this.setState({
            addEditOrderIdForDialog: undefined
        });
    }

    async onAddEditOrderSave(order) {
        const isNew = this.state.addEditOrderIdForDialog === "new";

        this.setState({
            addEditOrderIdForDialog: undefined
        });

        // Retrieving place id location
        const {data: placeIdLocation} = await axios.get('/api/v2a/placeIdGeocode', {
            params: {
                placeId: order.placeId,
                bid: this.props.match.params.bid
            }
        });

        const orderWithLocation = {...order, location: placeIdLocation};

        if (isNew)
            this.props.addOrder(orderWithLocation);
        else
            this.props.editOrder(orderWithLocation);
    }

    async onSendWithOrca(orderId) {
        this.setState({
            addEditOrderIdForDialog: undefined
        });

        this.props.sendWithOrca(this.context.bid, orderId);
    }

    onAddressSelect(address) {
        this.setState({
            selectedAddress: address
        });
    }

    onAddressChange(address) {
        this.setState({
            selectedAddress: address
        });
    }

    onNavigationChange(event, value) {
        this.setState({
            ordersNavigation: value
        });
    }

    onScanBarcodeClick() {
        this.setState({
            isScanBarcodeDialogOpen: true
        });
    }

    onBarcodeReaderDialogClose() {
        this.setState({
            isScanBarcodeDialogOpen: false
        });
    }

    onAddAddressClick() {
        this.setState({
            addEditOrderIdForDialog: "new",
            isBadAddress: false
        });
    }

    async onAutosuggestEnter(areSuggestionsShown) {
        if (!areSuggestionsShown)
            await this.onAddAddressClick();
    }

    static async fetchPredictions(address, bid) {
        const params = {
            address: address
        };

        if (bid)
            params.bid = bid;

        const {data: predictions} = await axios.get('/api/v2a/autocompleteAddress', {
            params: params
        });

        return predictions.map(prediction => {
            return {
                "label": prediction.address,
                "placeId": prediction.placeId,
                "location": prediction.location
            }
        });
    }

    generateNewOrderTemplate() {
        // Calculating next order number by its current max plus 1
        const nextLabel = (this.props.deliveryOrders.map(order => order.label.split(' ')[0]).filter(label => !isNaN(label)).reduce((a, b) => Math.max(a, b), 0) + 1).toString();

        const order = {
            label: nextLabel,
            id: uuid.v4(),
            status: this.props.orderStatusWhenAdded,
            orderTime: moment().utc().format().replace('Z', '+00:00'),
            timestamp: moment().utc().format().replace('Z', '+00:00'),
            paymentMethods: [],
            bid: this.props.match.params.bid,
            assignedTime: null,
            collectedTime: null,
            deliveredTime: null,
            source: "SHIPIT_WEB"
        };

        if (this.props.orderStatusWhenAdded === "SCHEDULED_READY") {
            order.minutesTillReady = this.props.scheduleReadyMinutesWhenAdded;
            order.scheduledMinutesTillReady = this.props.scheduledMinutesTillReady;
            order.scheduledReadyTime = moment().utc().format().replace('Z', '+00:00');
        }

        if (this.props.placesOfDeparture) {
            order.placeOfDeparture = this.props.placesOfDeparture[0].name;
        }

        return order;
    }

    findOrder(orderId) {
        if (!orderId)
            return undefined;

        if (orderId !== "new")
            return this.props.deliveryOrders.find((order) => order.id === orderId);

        return this.generateNewOrderTemplate();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !shallowEqualObjects({
            match: this.props.match,
            ordersByNavigation: this.state.ordersByNavigation,
            ordersNavigation: this.state.ordersNavigation,
            readySla: this.props.readySla,
            focusedOrderId: this.state.focusedOrderId,
            addEditOrderIdForDialog: this.state.addEditOrderIdForDialog,
            sureDeleteOrderId: this.state.sureDeleteOrderId,
            isScanBarcodeDialogOpen: this.state.isScanBarcodeDialogOpen,
            ignoredOrderIdsForGrouping: this.state.ignoredOrderIdsForGrouping,
            isMerukazotEnabled: this.props.isMerukazotEnabled,
            merukazotMin: this.props.merukazotMin
        }, {
            match: nextProps.match,
            ordersByNavigation: nextState.ordersByNavigation,
            ordersNavigation: nextState.ordersNavigation,
            readySla: nextProps.readySla,
            focusedOrderId: nextState.focusedOrderId,
            addEditOrderIdForDialog: nextState.addEditOrderIdForDialog,
            sureDeleteOrderId: nextState.sureDeleteOrderId,
            isScanBarcodeDialogOpen: nextState.isScanBarcodeDialogOpen,
            ignoredOrderIdsForGrouping: nextState.ignoredOrderIdsForGrouping,
            isMerukazotEnabled: nextProps.isMerukazotEnabled,
            merukazotMin: nextProps.merukazotMin
        });
    }

    render() {
        const ordersForGrid = this.state.ordersByNavigation[this.state.ordersNavigation];

        return (
            <div className="orders">
                <div className="orders-title-container">
                    <div className="orders-title">
                        הזמנות
                    </div>
                </div>
                <div className="grid-address-container">
                    <div className="grid-container">
                        {ordersForGrid.length === 0 ?
                            <NoOrders type={this.state.ordersNavigation}/>
                            :
                            <OrdersGrid ref={this.ordersGridRef}
                                        orders={ordersForGrid}
                                        ignoredOrderIdsForGrouping={this.state.ignoredOrderIdsForGrouping}
                                        isRedirect={this.props.isRedirect}
                                        isAutopilot={this.props.isAutopilot}
                                        readySla={this.props.readySla}
                                        isScheduleNotificationsEnabled={this.props.isScheduleNotificationsEnabled}
                                        focusedOrderId={this.state.focusedOrderId}
                                        isMerukazotEnabled={this.props.isMerukazotEnabled}
                                        merukazotMin={this.props.merukazotMin}
                                        onOrderClicked={this.onOrderClicked.bind(this)}
                                        onOrderHover={this.onRowHover.bind(this)}
                                        onOrderHoverOut={this.onRowHoverOut.bind(this)}
                                        onOrderDepartureChanged={this.onOrderDeparturePlaceChanged.bind(this)}
                                        onOrderDeleteClicked={this.onOrderDeleteClicked.bind(this)}
                                        onOrderEditClicked={this.onOrderEditClicked.bind(this)}
                                        onOrderBadAddressClick={(orderId) => this.onOrderEditClicked(orderId, true)}
                                        onGroupOffClicked={this.onGroupOffClicked.bind(this)}
                            />
                        }
                    </div>
                    {
                        this.state.ordersNavigation === "ACCEPTED_READY" && this.context.permissions.isPermitted(permissionTypes.ADD_EDIT_SHIPMENT) ?
                            <div className="orders-actions">
                                <Tooltip disableFocusListener={true} arrow
                                         title="צור הזמנה חדשה">
                                    <Fab className="add-address-button" aria-label="Add" size="small"
                                         onClick={this.onAddAddressClick.bind(this)}>
                                        <AddIcon/>
                                    </Fab>
                                </Tooltip>
                            </div>
                            :
                            false
                    }
                </div>
                <BottomNavigation
                    className="orders-tabs-buttons"
                    value={this.state.ordersNavigation}
                    onChange={this.onNavigationChange.bind(this)}
                    showLabels>
                    {/*TODO: Consider another icon for accepted/ready*/}
                    <BottomNavigationAction
                        classes={{
                            root: this.props.classes.actionItemStyles,
                            selected: this.props.classes.selected
                        }}
                        label={`ממתינות (${this.state.ordersByNavigation["ACCEPTED_READY"].length})`}
                        value="ACCEPTED_READY"
                        icon={<AlarmIcon/>}/>
                    <BottomNavigationAction
                        classes={{
                            root: this.props.classes.actionItemStyles,
                            selected: this.props.classes.selected
                        }}
                        label={`בדרכים (${this.state.ordersByNavigation["ON_THE_WAY"].length})`}
                        value="ON_THE_WAY"
                        icon={<MotorcycleIcon/>}/>
                    <BottomNavigationAction
                        classes={{
                            root: this.props.classes.actionItemStyles,
                            selected: this.props.classes.selected
                        }}
                        label={'נמסרו'}
                        value="DELIVERED"
                        icon={<DoneIcon/>}/>
                </BottomNavigation>

                <BarcodePasteReaderListenerDialogContainer/>
                <AddEditOrderDialogContainer
                    isNew={!!(this.state.addEditOrderIdForDialog && this.state.addEditOrderIdForDialog === "new")}
                    isBadAddress={this.state.isBadAddress}
                    open={this.state.addEditOrderIdForDialog !== undefined}
                    order={this.state.addEditOrderIdForDialog ? this.findOrder(this.state.addEditOrderIdForDialog) : undefined}
                    onSave={this.onAddEditOrderSave.bind(this)}
                    onCancel={this.onAddEditOrderCancel.bind(this)}
                    onSendWithOrca={this.onSendWithOrca.bind(this)}/>
                <AreYouSureDialog open={!!this.state.sureDeleteOrderId}
                                  onYes={this.onSureDeleteOrder.bind(this)}
                                  onNo={this.onNotSureDeleteOrder.bind(this)}
                                  titleText={"האם אתה בטוח שברצונך למחוק הזמנה זו?"}
                />
            </div>
        );
    }
}

export default Orders;